import { Resource, Resources } from './Resources'

const AppService = {
  kanbanBoards: new Resources('kanban_boards'),
  kanbanColumns: new Resources('kanban_columns'),
  kanbanCards: new Resources('kanban_cards'),
  kanbanBoardCollaborators: new Resources('kanban_board_collaborators')
}

export default AppService
